// import React, { useState, useEffect } from 'react';
// import {
//   Box,
//   TextField,
//   IconButton,
//   Button,
//   FormHelperText
// } from '@mui/material';
// import DeleteIcon from '@mui/icons-material/Delete';
// import AddIcon from '@mui/icons-material/Add';
// import { api } from '../helpers/apiRequest';
// const PackingItemsTable = ({ items, handleItemChange, handleRemoveItem, formIndex, errors }) => {
//   const sizeOptions = ['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'];
//   const [colors, setColors] = useState([]);

//   const fetchColors = async () => {
//     try {
//       const response = await api.get('inventory/colors');
//       setColors(response?.data?.message || []);
//     } catch (error) {
//       console.error('Error fetching colors:', error);
//     }
//   };

//   useEffect(() => {
//     fetchColors();
//   }, []);

  

//   const getItemErrors = (index) => {
//     return errors?.items?.[formIndex]?.[index] || {};
//   };



//   return (
//     <Box>
//       {/* <Box sx={{
//         display: 'flex',
//         gap: 1,
//         mb: 1,
//         backgroundColor: colors.primary,
//         p: 1,
//         textAlign: 'center',
//         borderRadius: '4px 4px 0 0',
//         '& > div': {
//           color: 'black',
//           fontWeight: 500,
//           fontSize: '0.9rem',
//           width: '8%'
//         },
//         '& > div:first-of-type': {
//           width: '14%'
//         }
//       }}>
//         <Box sx={{ width: '14%' }}>Color</Box>
//         {sizeOptions.map((size) => (
//           <Box key={size}>{size}</Box>
//         ))}
//         <Box>Total Pieces</Box>
//         <Box>Per box</Box>
//         <Box>Total Box</Box>
//         <Box sx={{ width: '5%' }}>Action</Box>
//       </Box> */}
// <Box
//   sx={{
//     display: "flex",
//     gap: 1,
//     mb: 1,
//     backgroundColor: colors.primary,
//     p: 1,
//     textAlign: "center",
//     borderRadius: "4px 4px 0 0",
//     "& > div": {
//       color: "black",
//       fontWeight: 500,
//       fontSize: "0.9rem",
//       width: "8%",
//       display: "flex",
//       justifyContent: "center",
//       alignItems: "center",
//     },
//     "& > div:first-of-type": {
//       width: "14%",
//     },
//   }}
// >
//   <Box sx={{ width: "14%" }}>Color</Box>
//   <Box>XS</Box>
//   <Box>S (6M/2Y)</Box>
//   <Box>M (12M/4Y)</Box>
//   <Box>L (12M/6Y)</Box>
//   <Box>XL</Box>
//   <Box>2XL</Box>
//   <Box>3XL</Box>
//   <Box>Total Pieces</Box>
//   <Box>Per box</Box>
//   <Box>Total Box</Box>
//   <Box sx={{ width: "5%" }}>Action</Box>
// </Box>

//       <Box sx={{
//         border: '1px solid #e0e0e0',
//         borderRadius: '0 0 4px 4px',
//         backgroundColor: '#f8f8f8',
//         p: 1
//       }}>
//         {items.map((item, index) => {
//           const itemErrors = getItemErrors(index);
//           return (
//             <Box key={index} sx={{
//               display: 'flex',
//               gap: 1,
//               mb: 0.5,
//               alignItems: 'flex-start',
//               '& .MuiTextField-root': {
//                 backgroundColor: 'white',
//               }
//             }}>
//               <Box sx={{ width: '14%' }}>
//                 <TextField
//                   label="Color"
//                   value={item.color || ''}
//                   onChange={(e) => handleItemChange(index, 'color', e.target.value)}
//                   // options={colors?.map((c) => ({ id: c.name, name: c.name })) || []}
//                   error={!!itemErrors?.color}
//                   helperText={itemErrors?.color}
//                   fullWidth
//                 />
//               </Box>
              
//               {sizeOptions.map((sizeOption) => (
//                 <Box key={sizeOption} sx={{ width: '8%' }}>
//                   <TextField
//                     label={sizeOption}
//                     type="number"
//                     value={item.sizes.find(s => s.size === sizeOption)?.quantity || ''}
//                     onChange={(e) => handleItemChange(index, sizeOption, e.target.value)}
//                     fullWidth
//                     InputProps={{
//                       inputProps: { min: 0 }
//                     }}
//                   />
//                   {itemErrors?.sizes && (
//                     <FormHelperText error>{itemErrors.sizes}</FormHelperText>
//                   )}
//                 </Box>
//               ))}
              
//               <Box sx={{ width: '8%' }}>
//                 <TextField
//                   type="number"
//                   value={item.total_pieces || 0}
//                   InputProps={{ readOnly: true }}
//                   fullWidth
//                 />
//               </Box>
              
//               <Box sx={{ width: '8%' }}>
//                 <TextField
//                   // type="number"
                  
//                   value={item.per_box || 0}
//                   onChange={(e) => handleItemChange(index, 'per_box', e.target.value)}
//                   fullWidth
//                   error={!!itemErrors?.per_box}
//                 />
//                 {itemErrors?.per_box && (
//                   <FormHelperText error>{itemErrors.per_box}</FormHelperText>
//                 )}
//               </Box>
              
//               <Box sx={{ width: '8%' }}>
//                 <TextField
//                   type="number"
//                   value={item.total_box || 0}
//                   InputProps={{ readOnly: true }}
//                   fullWidth
//                 />
//               </Box>
              
//               {items.length > 1 && (
//                 <IconButton
//                   onClick={() => handleRemoveItem(index)}
//                   sx={{ width: '5%' }}
//                 >
//                   <DeleteIcon />
//                 </IconButton>
//               )}
//             </Box>
//           );
//         })}

//         <Button
//           variant="outlined"
//           startIcon={<AddIcon />}
//           onClick={() => handleItemChange(items.length, 'color', '')}
//           fullWidth
//           sx={{
//             mt: 1,
//             borderColor: colors.primary,
//             color: 'black',
//             '&:hover': {
//               borderColor: colors.primary,
//               backgroundColor: colors.primary,
//               opacity: 0.9,
//             },
//           }}
//         >
//           Add Row
//         </Button>
//       </Box>
//     </Box>
//   );
// };

// export default PackingItemsTable; 


import React, { useState, useEffect } from 'react';
import {
  Box,
  TextField,
  IconButton,
  Button,
  FormHelperText
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import { api } from '../helpers/apiRequest';

const PackingItemsTable = ({ items, handleItemChange, handleRemoveItem, formIndex, errors }) => {
  const sizeOptions = ['XS','S', 'M', 'L', 'XL', '2XL','3XL', 'MIX'];
  const [colors, setColors] = useState([]);

  const fetchColors = async () => {
    try {
      const response = await api.get('inventory/colors');
      setColors(response?.data?.message || []);
    } catch (error) {
      console.error('Error fetching colors:', error);
    }
  };

  useEffect(() => {
    fetchColors();
  }, []);

  const getItemErrors = (index) => {
    return errors?.items?.[formIndex]?.[index] || {};
  };

  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      {/* Header Row */}
      <Box
        sx={{
          display: "flex",
          gap: 1,
          mb: 1,
          backgroundColor: colors.primary,
          p: 1,
          textAlign: "center",
          borderRadius: "4px 4px 0 0",
          minWidth: "900px", // force scroll when screen is smaller
          "& > div": {
            color: "black",
            fontWeight: 500,
            fontSize: "0.9rem",
            width: "8%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          },
          "& > div:first-of-type": {
            width: "14%",
          },
        }}
      >
        <Box sx={{ width: "14%" }}>Color</Box>
        <Box>XS</Box>
        <Box>S (6M/2Y)</Box>
        <Box>M (12M/4Y)</Box>
        <Box>L (12M/6Y)</Box>
        <Box>XL</Box>
        <Box>2XL</Box>
        <Box>3XL</Box>
        <Box>Total Pieces</Box>
        <Box>Per box</Box>
        <Box>Total Box</Box>
        <Box sx={{ width: "5%" }}>Action</Box>
      </Box>

      {/* Table Body */}
      <Box
        sx={{
          border: '1px solid #e0e0e0',
          borderRadius: '0 0 4px 4px',
          backgroundColor: '#f8f8f8',
          p: 1,
          minWidth: "900px" // ensures body matches header
        }}
      >
        {items.map((item, index) => {
          const itemErrors = getItemErrors(index);
          return (
            <Box
              key={index}
              sx={{
                display: 'flex',
                gap: 1,
                mb: 0.5,
                alignItems: 'flex-start',
                '& .MuiTextField-root': {
                  backgroundColor: 'white',
                }
              }}
            >
              <Box sx={{ width: '14%' }}>
                <TextField
                  label="Color"
                  value={item.color || ''}
                  onChange={(e) => handleItemChange(index, 'color', e.target.value)}
                  error={!!itemErrors?.color}
                  helperText={itemErrors?.color}
                  fullWidth
                />
              </Box>

              {sizeOptions.map((sizeOption) => (
                <Box key={sizeOption} sx={{ width: '8%' }}>
                  <TextField
                    label={sizeOption}
                    type="number"
                    value={item.sizes.find(s => s.size === sizeOption)?.quantity || ''}
                    onChange={(e) => handleItemChange(index, sizeOption, e.target.value)}
                    fullWidth
                    InputProps={{
                      inputProps: { min: 0 }
                    }}
                  />
                  {itemErrors?.sizes && (
                    <FormHelperText error>{itemErrors.sizes}</FormHelperText>
                  )}
                </Box>
              ))}

              <Box sx={{ width: '8%' }}>
                <TextField
                  type="number"
                  value={item.total_pieces || 0}
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
              </Box>

              <Box sx={{ width: '8%' }}>
                <TextField
                  value={item.per_box || 0}
                  onChange={(e) => handleItemChange(index, 'per_box', e.target.value)}
                  fullWidth
                  error={!!itemErrors?.per_box}
                />
                {itemErrors?.per_box && (
                  <FormHelperText error>{itemErrors.per_box}</FormHelperText>
                )}
              </Box>

              <Box sx={{ width: '8%' }}>
                <TextField
                  type="number"
                  value={item.total_box || 0}
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
              </Box>

              {items.length > 1 && (
                <IconButton
                  onClick={() => handleRemoveItem(index)}
                  sx={{ width: '5%' }}
                >
                  <DeleteIcon />
                </IconButton>
              )}
            </Box>
          );
        })}

        <Button
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={() => handleItemChange(items.length, 'color', '')}
          fullWidth
          sx={{
            mt: 1,
            borderColor: colors.primary,
            color: 'black',
            '&:hover': {
              borderColor: colors.primary,
              backgroundColor: colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Add Row
        </Button>
      </Box>
    </Box>
  );
};

export default PackingItemsTable;
